import * as moment from 'moment';
import { RegisterItem } from '../decorators/snitem-factory-decorator';
import { CNServiceCodeExtra } from './cnservicecode';
import { SNItem } from './snitem';

@RegisterItem()
export class CNServiceCodeINAMIValue extends SNItem {
    constructor(itemid: number = 0) {
        super(itemid);
        this.key = 'SNItem.CNItem.CNServiceCode.CNServiceCodeINAMIValue';
    }

    get label(): string {
        return this.getProperty('label');
    }

    set label(aLabel: string) {
        this.setProperty('label', aLabel);
        this.value = aLabel;
    }

    get price(): string {
        return this.getProperty('price');
    }

    set price(price: string) {
        this.setProperty('price', price);
    }

    get inamigroup(): string {
        return this.getProperty('inamigroup');
    }

    set inamigroup(group: string) {
        this.setProperty('inamigroup', group);
    }

    get dmg(): boolean {
        return this.getProperty('dmg') === 'Yes' ? true : false;
    }

    set dmg(flag: boolean) {
        this.setProperty('dmg', flag ? 'Yes' : 'No');
    }

    get chronique(): boolean {
        return this.getProperty('chronique') === 'Yes' ? true : false;
    }

    set chronique(flag: boolean) {
        this.setProperty('chronique', flag ? 'Yes' : 'No');
    }

    get stagiaire(): boolean {
        return this.getProperty('stagiaire') === 'Yes' ? true : false;
    }

    set stagiaire(flag: boolean) {
        this.setProperty('stagiaire', flag ? 'Yes' : 'No');
    }

    get accredit(): boolean {
        return this.getProperty('accredit') === 'Yes' ? true : false;
    }

    set accredit(flag: boolean) {
        this.setProperty('accredit', flag ? 'Yes' : 'No');
    }

    get aftermg(): boolean {
        return this.getProperty('aftermg') === 'Yes' ? true : false;
    }

    set aftermg(flag: boolean) {
        this.setProperty('aftermg', flag ? 'Yes' : 'No');
    }

    get startage(): string {
        return this.getProperty('startage');
    }

    set startage(age: string) {
        this.setProperty('startage', age);
    }

    get stopage(): string {
        return this.getProperty('stopage');
    }

    set stopage(age: string) {
        this.setProperty('stopage', age);
    }

    get startdate(): Date {
        return (this.getProperty('startdate') !== null && this.getProperty('startdate').length !== 0) ?
            moment(this.getProperty('startdate'), 'DD/MM/YYYY').toDate() : undefined;
    }

    set startdate(date: Date) {
        this.setProperty('startdate', moment(date).format('DD/MM/YYYY'));
    }

    get stopdate(): Date {
        return (this.getProperty('stopdate') !== null && this.getProperty('stopdate').length !== 0) ?
            moment(this.getProperty('stopdate'), 'DD/MM/YYYY').toDate() : undefined;
    }

    set stopdate(date: Date) {
        this.setProperty('startdate', moment(date).format('DD/MM/YYYY'));
    }

    public clone(): any {
        return new CNServiceCodeINAMIValue();
    }
}
